import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconAmazonPo: React.FC<IconProps> = ({
  size = 15,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <g clipPath="url(#clip0_amazon_po)">
      <path
        d="M8.87184 4.18897C8.50889 4.21777 8.08961 4.24657 7.67034 4.30289C7.02829 4.38548 6.38624 4.49813 5.856 4.74885C4.82305 5.16983 4.12468 6.06386 4.12468 7.37845C4.12468 9.0293 5.18601 9.86659 6.52558 9.86659C6.97323 9.86659 7.33576 9.81196 7.67034 9.72768C8.20185 9.55997 8.64865 9.25207 9.17889 8.69388C9.48678 9.11316 9.56979 9.30925 10.1009 9.75648C10.2402 9.8128 10.3796 9.8128 10.4914 9.72853C10.8264 9.44943 11.4121 8.94587 11.72 8.66635C11.8589 8.55327 11.8314 8.38683 11.7479 8.24623C11.44 7.8549 11.1338 7.51863 11.1338 6.76478V4.24784C11.1338 3.18355 11.2164 2.20565 10.4363 1.47933C9.79341 0.890222 8.78841 0.667877 8.00745 0.667877C7.89564 0.667877 7.78426 0.667877 7.67203 0.667877C6.24818 0.751309 4.74089 1.3654 4.40505 3.12891C4.34999 3.35126 4.51812 3.43638 4.62951 3.46476L6.1927 3.66127C6.36041 3.63162 6.44384 3.49271 6.47137 3.35211C6.6124 2.73843 7.11426 2.43054 7.67245 2.37421C7.70083 2.37421 7.72878 2.37421 7.78468 2.37421C8.11926 2.37421 8.48179 2.51482 8.67787 2.79222C8.89937 3.12891 8.87311 3.57699 8.87311 3.96747L8.87184 4.18897ZM8.5648 7.51694C8.36956 7.90869 8.03413 8.16025 7.67118 8.24453C7.6157 8.24453 7.53269 8.27333 7.44841 8.27333C6.83432 8.27333 6.4701 7.79773 6.4701 7.09808C6.4701 6.20447 7.00118 5.7835 7.67118 5.58826C8.03413 5.50482 8.45341 5.47603 8.87227 5.47603V5.81187C8.87184 6.45561 8.8981 6.95832 8.5648 7.51694ZM15.0001 11.4001V11.4912C14.9853 12.0379 14.6968 13.087 14.0141 13.6642C13.8778 13.7701 13.741 13.7096 13.8011 13.5567C13.9997 13.0717 14.4538 11.946 14.2416 11.6881C14.0912 11.4912 13.4682 11.506 12.9376 11.5517C12.6953 11.5822 12.4823 11.5962 12.3154 11.6293C12.1642 11.6432 12.1329 11.5077 12.2854 11.4018C12.4827 11.265 12.6957 11.1592 12.938 11.0817C13.8015 10.8242 14.804 10.9758 14.9408 11.1435C14.9704 11.1867 15.0001 11.2777 15.0001 11.4001ZM13.5593 12.4632C13.3619 12.6143 13.1506 12.752 12.9376 12.8752C11.3447 13.8328 9.28223 14.3325 7.49288 14.3325C4.61003 14.3325 2.03168 13.2687 0.075468 11.4912C-0.0922433 11.354 0.0445515 11.157 0.241909 11.2629C2.35016 12.4936 4.959 13.239 7.6589 13.239C9.35846 13.239 11.1919 12.9197 12.9372 12.2349C13.0579 12.1908 13.1946 12.1282 13.3162 12.0841C13.5894 11.9609 13.8325 12.2671 13.5593 12.4632Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_amazon_po">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconAmazonPo;
